<div class="ir-area ir-mask th-mask">
  <form *ngIf="customerForm" class="ir-modal th-modal" (ngSubmit)="save(customerForm.value)" [formGroup]="customerForm">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin">
              <h2>
                <span><strong>{{ 'plugins.customer-info.customer' | translate }} #<i>*</i></strong></span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message [validationControl]="customerForm.controls.CrmId" [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"></validation-message>
                <input name="crmId" class="ir-form-set" type="text" formControlName="CrmId" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span><strong>{{ 'plugins.customer-info.customer-name' | translate }}<i>*</i></strong></span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message [validationControl]="customerForm.controls.Name" [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"></validation-message>
                <input name="Name" class="ir-form-set" type="text" formControlName="Name" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.customer-info.address' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message [validationControl]="customerForm.controls.Address" [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"></validation-message>
                <input name="Address" class="ir-form-set" type="text" formControlName="Address" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.customer-info.city' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message [validationControl]="customerForm.controls.City" [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"></validation-message>
                <input name="City" class="ir-form-set" type="text" formControlName="City" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span><strong>{{ 'plugins.customer-info.country' | translate }}<i>*</i></strong></span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message [validationControl]="customerForm.controls.Country" [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"></validation-message>
                <input type="hidden" name="Country" class="ir-form-set" formControlName="Country" />
                <div class="ir-line ir-select th-select" (click)="openCountriesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      customerForm.controls.Country.value
                      ? (customerForm.controls.Country.value | country | async)
                      : ('plugins.customer-info.select-country' | translate)
                      }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span><strong>{{ 'plugins.customer-info.localEntity' | translate }}<i>*</i></strong></span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message [validationControl]="customerForm.controls.LocalEntity" [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"></validation-message>
                <input type="hidden" name="LocalEntity" class="ir-form-set" formControlName="LocalEntity" />
                <div class="ir-line ir-select th-select" (click)="openLocalEntitiesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      customerForm.controls.LocalEntity.value
                      ? (customerForm.controls.LocalEntity.value | localEntity)
                      : ('plugins.customer-info.select-localEntity' | translate)
                      }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span><strong>{{ 'plugins.customer-info.contact-name' | translate }}<i>*</i></strong></span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message [validationControl]="customerForm.controls.Contact" [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"></validation-message>
                <input name="Contact" class="ir-form-set" type="text" formControlName="Contact" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span><strong>{{ 'plugins.customer-info.contact-email' | translate }} <i>*</i></strong></span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <validation-message [validationControl]="customerForm.controls.Email" [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"></validation-message>
                <validation-message [validationControl]="customerForm.controls.Email" [validationName]="'emailvalidator'"
                  [errorMessage]="'common.email-not-valid' | translate"></validation-message>
                <input name="Email" class="ir-form-set" type="text" formControlName="Email" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span><strong>{{ 'plugins.customer-info.contact-telephone' | translate }}<i>*</i></strong></span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <validation-message [validationControl]="customerForm.controls.Tel" [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"></validation-message>
                <input name="Tel" placeholder="+41 21 123 45 67" class="ir-form-set" type="tel" formControlName="Tel" />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h2>
                <span><strong>{{ 'plugins.customer-info.languages' | translate }}<i>*</i></strong></span>
              </h2>
            </td>
            <td>
              <div class="ir-form-group">
                <validation-message [validationControl]="customerForm.controls.Language" [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"></validation-message>
                <input type="hidden" name="Language" class="ir-form-set" formControlName="Language" />
                <div class="ir-line ir-select th-select" (click)="openLanguagesSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      customerForm.controls.Language.value
                      ? (customerForm.controls.Language.value | languages)
                      : ('plugins.customer-info.select-language' | translate)
                      }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right" type="submit"
            [disabled]="customerForm.invalid" *ngIf="!processing">
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right" type="submit"
            *ngIf="processing">
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="selectLanguagesMenu($event)" (modalClosed)="onLanguagesMenuClose()" #languagesModal></modal>
<modal (modalOutput)="selectCountriesMenu($event)" (modalClosed)="onCountriesMenuClose($event)" #countriesModal></modal>
<modal (modalOutput)="selectLocalEntitiesMenu($event)" (modalClosed)="onLocalEntitiesMenuClose($event)"
  #localEntitiesModal></modal>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm #deleteConfirm (confirmOutput)="deletePlugin()" [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate" [danger]="true"></confirm>
